/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErroreClientProblemaDTO { 
    id?: string;
    app?: string;
    origine?: string;
    tipo?: string;
    messaggio?: string;
    prima_riga_stack?: string;
    form?: string;
    campo?: string;
    regola?: string;
    contatore?: number;
    utenti_distinti?: number;
    soggetti_distinti?: number;
    prima_occorrenza?: string;
    ultima_occorrenza?: string;
}

